// export let BASE_URL = 'http://localhost:3001'
// export let BASE_URL = '__RUNTIME_API_URL__'
import React from 'react'
import { useLocation } from 'react-router-dom'
export let BASE_URL;
function ConfigReact() {
    let location = useLocation()
    console.log(location.pathname, "location");
    if (location.pathname === "/sit") {
        BASE_URL = '__RUNTIME_API_URL__'
    } else if (location.pathname === "/pro") {
        BASE_URL = '__RUNTIME_API_URL__'
    } else {
        // defalt sit api lega 
        BASE_URL = '__RUNTIME_API_URL__'
    }
    return (
        <div></div>
    )
}

export default ConfigReact

